<template>
    <v-app id="app" v-bind:style="stylePagina">
        <v-container >
            <v-dialog v-model="perdio" persistent max-width="350">
                <v-card>
                    <v-card-title class="headline">Ud ha PERDIDO</v-card-title>
                    <v-card-text>Lamentablemente ha superado los turnos permitidos.</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="terminarJuego">Volver a Jugar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="gano" persistent max-width="350">
                <v-card>
                    <v-card-title class="headline">Ud ha GANADO!</v-card-title>
                    <v-card-text>Genial tiene una memoria increible!.</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="terminarJuego">Volver a Jugar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-row justify="center" align="center"  class="mt-12 mb-12 pb-12"  >
                <v-col cols="12" lg="10" xl="10"  v-bind:style="styleCuadro" class="mt-12 pt-12 pb-12">
                    <v-row justify="center" align="center" >
                        <v-col cols="12" xl="8" lg="8" >
                            <v-img style="width: 100%;" :src="logo"></v-img>
                        </v-col>
                    </v-row>
    <v-row v-if="conformulario"  >
        <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1">
            <input type="text" :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"   v-bind:style="styleComponent" v-model="editedItem.persona.nombrePersona" :placeholder="labelNombre" />
        </v-col>

        <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"  v-if="campodni" v-on:change="handleInputNumero"  v-bind:style="styleComponent" v-model="editedItem.persona.dniPersona" :placeholder="labelDNI" />
        </v-col>
        <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"   v-if="campotelefono"  v-on:change="handleInputNumero"  v-bind:style="styleComponent" v-model="editedItem.persona.telefonoPersona" :placeholder="labelTelefono" />
        </v-col>
        <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1">
            <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }" v-if="campoemail" v-on:change="handleEmailChange"   v-bind:style="styleComponent" v-model="editedItem.persona.emailPersona"  :placeholder="labelEmail" />
        </v-col>
        <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"  v-if="camporef1"  v-bind:style="styleComponent" v-model="editedItem.persona.ref1Persona" :placeholder="labelRef1" />
        </v-col>
        <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text" :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"    v-if="camporef2"  v-bind:style="styleComponent" v-model="editedItem.persona.ref2Persona" :placeholder="labelRef2" />
        </v-col>
        <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1" >
            <input type="text"  :class="{ 'white-placeholder': isWhitePlaceholder, 'black-placeholder': !isWhitePlaceholder }"  v-if="campodireccion"  v-bind:style="styleComponent" v-model="editedItem.persona.direccionPersona" :placeholder="labelDireccion" />
        </v-col>
        <v-col  cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1">

            <v-checkbox
                v-model="editedItem.aceptoCondicion"
                :rules="[v => !!v || 'Debes aceptar para continuar']"
                :label="condiciones"
                required
                style="color: #1E3D90 !important;"
                color="#1E3D90"
                class="ma-0"
            ></v-checkbox> <a :href="linkcondiciones" target="_blank">Link</a> </v-col>
        <v-col cols="10" sm="10" md="10" lg="10" class="ma-2  pa-1 text-center" >
            <center> <v-btn v-bind:style="btnPag" @click="comenzarJuego">Registrarse</v-btn></center>
        </v-col>

    </v-row>
    <v-row v-else justify="center" align="center" >
        <v-col cols="12" lg="12" md="12" sm="12">
 <v-row justify="center" align="center" >
        <v-col cols="5" lg="10" class="text-center text-h3">
            Turnos {{turnos}} - Máximo {{turnomax}}
        </v-col>
 </v-row>
            <v-row justify="center" align="center" >


        <v-col v-for="(item, index) in itemsCarta"  cols="5" sm="6" xl="2" lg="2" md="3" style="height:256px;" :key="index" class="card ma-2" :class="{ flipped: respuestas[index] !== 2 }" @click="flipcard(index)">

            <div class="card-front" v-show="respuestas[index] === 0 ">
                <v-img width="100%" aspect-ratio="16/9" height="256px"
                       contain :src="fotoCarta"   :rel="index"  />
            </div>
            <div class="card-front" v-show="respuestas[index] === 2 ">
                <v-img width="100%" aspect-ratio="16/9" height="256px"
                       contain :src="item"   :rel="index"  />
            </div>
            <div  class="card-back" v-show="respuestas[index] === 1">
                <v-img width="100%" aspect-ratio="16/9" height="256px"
                       contain :src="item"    class="image-transition" :eager="true" :rel="index"  />
            </div>
        </v-col>
            </v-row>
        </v-col>
    </v-row>
                </v-col></v-row>
        </v-container>
    </v-app>
</template>

<script>
import axios from "axios";

export default {
    name: "MemoriaCartas",
    data() {
        return {
            hasta:20,
            juegofin:false,
            arr : [],
            logo:'',
            turnomax:5,
            perdio:false,
            gano:false,
            turnos:0,
            clickeada:0,
            editedItem:{
                ganador:false,

                persona:{
                    fechaNacimientoPersona:null,
                    dniPersona:'',
                    fotoPersona:'',
                    nombrePersona:'',
                    tipoDocumentoPersona:'',
                    emailPersona:'',
                    telefonoPersona:'',
                    direccionPersona:'',
                    sexoPersona:'',
                    distritoPersona:'',
                    ref1Persona:'',
                    ref2Persona:''
                }

            },
            defaultItem:{
                ganador:false,
                persona:{
                    fechaNacimientoPersona:null,
                    dniPersona:'',
                    fotoPersona:'',
                    nombrePersona:'',
                    tipoDocumentoPersona:'',
                    emailPersona:'',
                    telefonoPersona:'',
                    direccionPersona:'',
                    sexoPersona:'',
                    distritoPersona:'',
                    ref1Persona:'',
                    ref2Persona:''
                }

            },
            campodireccion: false,
            campodistrito: false,
            campofecnac: false,
            campofoto: false,
            campoinvitado: false,
            campoizqder: false,
            camporeferido: false,
            camposexo: false,
            campotelefono: false,
            campofumador: false,
            campodni:false,
            linkcondiciones:'',
            campotipocarnet: false,
            campocondiciones:false,
            campoemail:false,
            camporef1: false,
            camporef2:false,
            condiciones: 'Soy Mayor de Edad',
            labelNombre:'Nombre',
            labelApellidoPaterno:'Apellido paterno',
            labelApellidoMaterno:'Apellido Materno',
            labelDNI:'Numero de Documento',
            labelDistrito: 'Comuna',
            labelTipoDocumento:'Tipo de Documento',
            labelFechaNacimiento: 'Fecha de nacimiento',
            labelEmail:'Correo Electrónico',
            labelSexo:'Género',
            labelTelefono:'Telefono',
            labelDireccion:'Direccion',
            labelRef1:'',
            labelRef2:'',
            stylePagina: {
                fontColor:'black',
                fontFamily: 'Futura Bk BT',
                color: '#1E3D90',
                backgroundColor:'#FFD101'
            },
            styleComponent:{
                color:'#ffffff',
                backgroundColor:'#FFD101',
                width:'100%',
                padding:'10px'
            },
            styleCuadro:{
                color:'#1E3D90',
                backgroundColor:'#FFD101'
            },
            btnPag: {
                backgroundColor: '#1E3D90',
                color:'white',
                cursor: 'pointer',
                fontSize:'1.5rem',
                margin: '0 0.2rem',
                height:'50px',
                border: 'none',
                borderRadius: '10px',
                padding: '10px 15px',
            },
            conformulario: true,
            gridjuego:false,
            isWhitePlaceholder: true,
            cantidadNumeros: 20,
            activo: '',
            tipo: '',
            //fotoCarta:'https://s3-us-west-2.amazonaws.com/s.cdpn.io/102308/card_backside.jpg',
            fotoCarta:'https://tunaydisenio.s3.sa-east-1.amazonaws.com/nttdata/backnttdata.png',
            itemsCarta:[],
            figuras:['https://i.imgur.com/5St6uf6.png','https://i.imgur.com/SWASqKJ.png','https://i.imgur.com/J7Ybtqb.png','https://i.imgur.com/mEfuqTr.png','https://i.imgur.com/4QkHmlg.png','https://i.imgur.com/I20udlN.png','https://i.imgur.com/ryKQPnR.png','https://i.imgur.com/WaaEUld.png','https://i.imgur.com/uGcJUuG.png','https://i.imgur.com/1Th2YEW.png'],
            itemsCartaClone:[],
            pool:[],
            respuestas:[],
            caja: '',
            contador: 0
        }
    },
    created () {
        this.$vuetify.theme.dark = false
    },
    mounted(){
        this.tag =  this.$route.params.tag;

        this.dameitems();

    },
    methods:{
        dameitems(){
            axios
                .get('juegos/memoriacartas/items/'+this.tag)
                .then(response => {
                        let figurwas = response.data
                    this.figuras = []
                    figurwas.forEach((entry)=>{
                        this.figuras.push(entry.imagen)
                    });
                    this.hasta = this.figuras.length *  2
                    this.damedisenio();
                    this.cartasComienzo();
                })
                .catch((error)  => {
                    console.log(error);
                });

        },
        damedisenio(){
            axios
                .get('disenio/juego/'+this.tag)
                .then(response => {
                    this.juegodisenio = response.data;

                    this.logo = this.juegodisenio.logo;
                    this.conformulario = this.juegodisenio.juego.conFormulario;
                    this.grabarformulario = this.juegodisenio.juego.conFormulario;
                    this.styleCuadro.backgroundColor = this.juegodisenio.fondoCuadro + " !important";
                    this.stylePagina.backgroundColor = this.juegodisenio.backgroundColor + " !important";
                    this.styleComponent.backgroundColor = this.juegodisenio.backCabeceraColor + " !important";
                    this.styleComponent.color = this.juegodisenio.colorInput + " !important";
                    this.condiciones = this.juegodisenio.condiciones;
                    this.linkcondiciones = this.juegodisenio.linkCondiciones;
                    this.campoapmaterno= this.juegodisenio.campoapmaterno;
                    this.labelApellidoMaterno = this.juegodisenio.labelApmaterno;
                    this.labelApellidoPaterno = this.juegodisenio.labelAppaterno;
                    this.labelTelefono = this.juegodisenio.labelTelefono;
                    this.campotelefono = this.juegodisenio.campotelefono;
                    this.campoinvitado = this.juegodisenio.campoinvitado;
                    this.camposexo = this.juegodisenio.camposexo;
                    this.campodireccion = this.juegodisenio.campodireccion;
                    this.campodni = this.juegodisenio.campodni;
                    this.campodistrito = this.juegodisenio.campodistrito;
                    this.labelDireccion= this.juegodisenio.labelDireccion;
                    this.campofecnac  = this.juegodisenio.campofecnac;
                    this.campoemail = this.juegodisenio.campoemail;
                    this.logoexist = this.juegodisenio.logoCargado;
                    this.logoimg = this.juegodisenio.logo;
                    this.stylePagina.color = this.juegodisenio.colorText + " !important";
                    this.btnPag.color = this.juegodisenio.colorTxtBoton + " !important";
                    this.btnPag.backgroundColor = this.juegodisenio.colorBgBoton+ " !important";
                    this.labelRef1 = this.juegodisenio.labelRef1;
                    this.labelRef2 = this.juegodisenio.labelRef2;
                    this.camporef1 = this.juegodisenio.camporef1;
                    this.camporef2 = this.juegodisenio.camporef2;
                    this.stylePagina.backgroundImage = "url('"+this.juegodisenio.backgroundImage+"')";
                    this.init();

                })
                .catch((error)  => {
                    console.log(error);
                });
        },
        flipcard(n){
                this.clickeada++;
                if(this.clickeada > 2){
                    this.clickeada = 1;
                }
            if(this.respuestas[n]!==2){
            this.itemsCarta[n] = this.pool[n]
           let posicion = this.respuestas.indexOf(parseInt(1))
            console.log("posicion")
            console.log(posicion)
            if(posicion === parseInt(-1)){
                this.respuestas[n]=1
                console.log("sin posicion")
                this.$forceUpdate();
            }else{
                console.log("con posicion")
                if(this.itemsCarta[n]=== this.itemsCarta[posicion]){
                    this.respuestas[n]=2
                    this.respuestas[posicion] = 2
                    this.$forceUpdate();
                }else{
                    this.respuestas[n]=1
                    this.$forceUpdate();
                    setTimeout(function(scope){
                        console.log("entro al tiempo")
                        scope.respuestas[n]=0
                        scope.respuestas[posicion] = 0
                        scope.itemsCarta[n]=this.fotoCarta;
                        scope.itemsCarta[posicion]=this.fotoCarta;
                        if(scope.clickeada === 2){
                            scope.turnos++;
                        }
                        scope.$forceUpdate();
                    }, 1000,this);

                }
            }
            }
            let posicion0 = this.respuestas.indexOf(parseInt(0))
            let posicion1 = this.respuestas.indexOf(parseInt(1))
            if(posicion0 === parseInt(-1) && posicion1 === parseInt(-1)  ){
                this.gano = true;
            }
            if(this.turnos > this.turnomax){
                this.perdio = true;
            }
        },
        cartasComienzo() {
            this.itemsCarta = [];
            this.clickeada = 0;
            let dsd = this.hasta/ 2
            this.respuestas = [];
            this.pool = [];
            this.itemsCartaClone = [];
            for(let i=0; i<this.hasta; i++){
                this.itemsCarta.push(this.fotoCarta)
                this.respuestas.push(0)

                if(i<dsd){
                this.itemsCartaClone.push(this.figuras[i]);
                this.itemsCartaClone.push(this.figuras[i]);}
            }

            this.pool.push(...this.shuffleArray(this.itemsCartaClone));

        },
        shuffleArray(arr) {
            let m = arr.length;
            while (m) {
                const i = Math.floor(Math.random() * m--);
                [arr[m], arr[i]] = [arr[i], arr[m]];
            }
            return arr;
        },
        terminarJuego() {
            this.turnos = 0;
            this.perdio = false;
            this.gano = false;
            this.cartasComienzo();
        },
        juego(e, y) {
            let activo = this.activo;
            let tipo = this.tipo;
            let caja = this.caja;
            let cartaRotarA = document.querySelector('.cP' + caja);
            let cajaA = document.querySelector('.caja' + caja);
            let cajaElement = document.querySelector('.caja' + y);
            let cartaRotar = document.querySelector('.cP' + y);

            if (activo === 'si') {
                cartaRotar.classList.add('rotar');
                if (tipo === e) {
                    if (parseInt(this.contador) === 9) {

                        setTimeout(() => {
                            cajaA.style.opacity = '0';
                            cajaElement.style.opacity = '0';
                        }, 500);
                        setTimeout(() => {
                            this.terminarJuego();
                        }, 400);
                    } else {
                        this.contador = parseInt(this.contador) + 1;

                        setTimeout(() => {
                            cajaA.style.opacity = '0';
                            cajaElement.style.opacity = '0';
                        }, 500);
                    }
                } else {

                    setTimeout(() => {
                        cartaRotar.classList.remove('rotar');
                        cartaRotarA.classList.remove('rotar');
                    }, 500);
                }
            } else {
                this.activo = 'si';
                this.tipo = e;
                this.caja = y;
                cartaRotar.classList.add('rotar');
            }
        },

        comenzarJuego() {
            this.conformulario= false;
        },


    }
}
</script>
<style>
.image-transition-enter-active,
.image-transition-leave-active {
    transition: opacity 0.5s;
}
.image-transition-enter,
.image-transition-leave-to {
    opacity: 0;
}
.card {
    width: 100px;
    height: 100px;
    background-color: #ffffff;
    border-radius: 5px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
}
.card.flipped {

}
.card-front,
.card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    backface-visibility: hidden;
}

.card-front {
    background-color: #ffffff;
    /* Estilos adicionales para la parte frontal de la carta */
}

.card-back {
    background-color: #ffffff;
    color: #fff;
    /* Estilos adicionales para la parte posterior de la carta */
}
</style>